<template>
  <div class="complianceMonitor">
    <!-- 导航栏 -->
    <nav-header :head-title="headTitle"></nav-header>
    <div class="container">
      <!-- 提示信息 -->
      <div class="tips">
        <!-- {{$route.query.timeRange}} -->
        <!-- 手卫生观察员需在正式监测期内（2021-09-01 ~ 2021-09-30）完成以下科室的手卫生监测，要求观察医疗和护理：共100个时机/科室 -->
        {{requestText}}
      </div>
      <!-- 标题栏 -->
      <div class="title-bar">
        <div class="text left">调查科室</div>
        <div class="text mid">{{$route.query.indexCode == 1 ? '观察医疗/护理时机数' : '观察医疗时机数'}}</div>
        <div class="text right">完成进度</div>
      </div>
      <!-- 科室容器 -->
      <van-collapse
        v-model="activeNames"
        v-if="deptCompletionList.length > 0 || hadLoaded == false"
      >
        <van-collapse-item
          :title="item.deptName"
          :name="index"
          :value="item.handTimeNumnName"
          v-for="(item, index) in deptCompletionList"
          :key="index"
        >
          <template #title>
            <div class="cell-title">
              <div class="dept_name">{{ item.deptName }}</div>
              <div class="dept_count">
                {{ item.docNum + ($route.query.indexCode == 1 ? "/" + item.nurseNum : "") }}
                <!-- 100/200 -->
              </div>
            </div>
          </template>
          <div
            class="unit-item-second-level df-between"
            v-for="(item2, index2) in item.children"
            :key="index2"
          >
            <div class="dept-name">{{ item2.wardName }}</div>
            <!-- <div class="count">已观察{{ item2.handTimeNum }}个时机</div> -->
            <div class="count">{{ item2.docNum + ($route.query.indexCode == 1 ? "/" + item2.nurseNum : "") }}</div>
            <div class="action df-center" @click="handleGoApp(item, item2, index)">
              <span>去观察</span>
              <img
                src="../../assets/images/monitorRecord/i-watch-arrow-right.png"
                alt=""
              />
            </div>
          </div>
          <template v-if="item.children.length === 0">
            <div style="height: 50px" class="df-center">暂无数据</div>
          </template>
        </van-collapse-item>
      </van-collapse>
      <empty-component v-else />
      <!-- <div class="unit-container">
      <div class="unit-container-item">
        <div class="unit-item-first-level df-between">
          <div class="dept-nam">骨科</div>
          <div class="compete-rate df-center">
            <div class="compete-status">已完成</div>
            <div class="expand-status"></div>
          </div>
        </div>
      </div>
    </div> -->
      <div style="height: 80px"></div>
    </div>

    <div class="watch-record-btn df-center" @click="jumpTo('/monitorRecord')">
      查看观察记录
    </div>
  </div>
</template>

<script>
import navHeader from "../../components/header/header.vue";
import Vue from "vue";
import emptyComponent from "../../components/empty-component/empty-component.vue";
import { mapState } from "vuex";
import { Collapse, CollapseItem, Dialog } from "vant";
Vue.use(Collapse);
Vue.use(CollapseItem);
export default {
  components: {
    navHeader,
    Collapse,
    emptyComponent,
    CollapseItem,
  },
  data() {
    return {
      requestText: '要求：手卫生观察员在正式监测期间观察医疗和护理不少于100个时机/科室，其中医疗和护理各50个时机及以上',
      headTitle: '',
      indexLibId: '',
      activeNames: ["1"],
      deptCompletionList: [],
      unitCollapseList: [],
      hadLoaded: false,
      localDeptStandardList: "",
      wksxdLocalDeptStandardList: "",
      localUserPost: "",
      deptTableList: []
    };
  },
  created() {
    if(this.$route.query.indexCode == 2){
      this.requestText = '要求：手卫生观察员在正式监测期间观察【手术部（室）】医疗（手术医生）不少于100人次全过程外科手消毒观察，如果手术量小，则尽可能完成观察次数'
      this.activeNames = [0]
    }
    this.indexLibId = this.$route.query.indexLibId
    this.headTitle = this.$route.query.titleName
    this.searchStandradDeptHandCompletionList();
    // window.addEventListener('pageshow', this.handleReappear)
    console.log("");
    this.initUserHandActivityInfo();
    this.searchStandardDeptHandDatas()
  },
  watch: {
    $router(to, from) {
      console.log(to, from, this.$router, "router....");
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log("进入进入...");
    });
  },
  beforeUpdate() {
    console.log("beforeUpdate.....");
  },
  updated() {
    console.log("update2222....");
  },
  beforeDestroy() {
    // 原生返回的时候调刷新方法
    window.refreshComplianceMonitor = function () {
      // console.log('调用刷新refreshComplianceMonitor....');
      // _this.searchStandradDeptHandCompletionList()
    };
  },
  mounted() {
    console.log("更新更新mounted...");
    let _this = this;
    // 原生返回的时候调刷新方法
    window.refreshComplianceMonitor = function () {
      console.log("调用刷新refreshComplianceMonitor....");
      _this.searchStandradDeptHandCompletionList();
    };
    window.addEventListener(
      "popstate",
      function (e) {
        console.log("刷新刷新popstate...");
      },
      false
    );
    //  console.log('onload777');
    //   var isPageHide = false;
    //  // 页面加载（是没有刷新页面的，跟页面刷新有着本质的不同）
    //   window.addEventListener('pageshow', function () {
    //     console.log('pageshow');
    //     // if (isPageHide) {
    //     //   window.location.reload();
    //     // }
    //   });
    //   window.addEventListener('pagehide', function () {
    //     console.log('pagehide');

    //     // isPageHide = true;
    //   });
    // ios返回不刷新
    // window.onload = function () {

    // };
  },
  computed: {
    ...mapState({
      _userInfo: (state) => state.InvestorInfo,
    }),
  },
  methods: {
    // 获取用户手卫生活动的用户信息
    initUserHandActivityInfo() {
      let params = {
        userId: this._userInfo.data.userId,
        sub_id: "",
        comId: this._userInfo.data.comId,
        data: {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          handTaskId: this.$route.query.taskId,
        },
        malVersion: "A0",
      };
      this.$http.getUserHandActivityInfo(params).then((res) => {
        console.log(res, "用户信息...");
        if (res.code === 0) {
          this.localDeptStandardList = res.data.deptStandardList;
          this.wksxdLocalDeptStandardList = res.data.deptStandardList1;
          this.localUserPost = res.data.userPost;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 刷新页面
    handleReappear() {
      console.log("history刷新页面");
      const { performance } = window;
      const { navigation } = performance || {};
      const { type } = navigation || {};

      const historyTraversal = event.persisted || type === 2;

      if (historyTraversal) {
        console.log("history刷新页面");
        // window.location.reload()
      }
    },
    // 获取上报统计范围
    searchStandardDeptHandDatas() {
      console.log(this._userInfo, "777");
      // return
      let params = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          taskId: this.$route.query.taskId,
          taskLinkId: this.$route.query.taskLinkId,
          indexCode: this.$route.query.indexCode
        },
      };

      this.$http.searchStandardDeptHandDatas(params).then((res) => {
        this.hadLoad = true;
        if (res.code == 0) {
          let arr = res.data ? res.data : [];
          arr.forEach((v) => {
            v.children = v.children ? v.children : [];
          });
          this.deptTableList = arr;
          console.log(this.deptTableList,'处理后的单元信息.... ');
          // this.deptTableList = [];
        } else {
          this.$toast(res.msg);
        }
        console.log(res);
      });
    },
    handleToast(item, item2){
      Dialog.confirm({
        title: "提示",
        message:
          "您当前的执行角色为非手卫生观察员，且未被指定纳入该科室的上报统计范围，所以您观察该科室的数据将不会纳入上报时机数",
        confirmButtonText: "去修改角色",
        cancelButtonText: "继续观察",
        closeOnClickOverlay: true,
      })
        .then(() => {
          sessionStorage.setItem('isEditRole','1')
          this.$router.go(-1);
        })
        .catch((res) => {
          if(res == 'cancel') {
            this._goWho(item, item2);
          }
      });
    },
    // 去观察
    handleGoApp(item, item2, index) {
      if(this.$route.query.stepIsEnd == '1'){
        this.$toast('活动已结束，不能继续观察')
        return
      }
      // 非手卫生观察员：统计范围无数据（this.deptTableList[index].children）或者不纳入统计（localDeptStandardList） 弹修改角色的窗  纳入统计不弹窗
      // 手卫生观察员：不纳入统计 弹继续观察的窗  统计范围无数据或者纳入统计不弹窗
      console.log(this.localUserPost,'this.localUserPost');
      console.log(this._userInfo.data.userId,'this._userInfo.data.userId');
      console.log(this.localDeptStandardList,'this.localDeptStandardList');
      console.log(this.deptTableList[index],'999');
      console.log(this.deptTableList[index].children,'===');
      // return
      if (this.localUserPost.indexOf("1") == -1) {
        let flag = false
        // 非手卫生观察员
        if(this.deptTableList[index].children == null || this.deptTableList[index].children.length == 0){
          flag = true
          this.handleToast(item, item2)
          return
        }
        this.deptTableList[index].children.forEach((v,i)=>{
          if((v.userId == this._userInfo.data.userId && v.isSelected !=1) || v.userId != this._userInfo.data.userId || !v.userId){ // isSelected!=1表示不纳入统计范围
            // 判断科室
            if (this.$route.query.indexCode == 1 ? (!this.localDeptStandardList || this.localDeptStandardList.indexOf(`${item2.deptId}`) == -1) : (!this.wksxdLocalDeptStandardList || this.wksxdLocalDeptStandardList.indexOf(`${item2.deptId}`) == -1)) {
              // // 未被纳入
              flag = true
              this.handleToast(item, item2)
              return
            }
          }
        })
        if(!flag){
          setTimeout(()=>{
            // 在科室里 =直接去观察
            this._goWho(item, item2);
          },200)
        }
      } else {
        // 是手卫生观察员
        let flag = false
        this.deptTableList[index].children.forEach((v,i)=>{
          if(v.userId == this._userInfo.data.userId && v.isSelected !=1){
            // 未被纳入
            flag = true
            Dialog.confirm({
              title: "提示",
              message:
                "您已被感控科主任移出该科室的上报统计范围，所以您观察该科室的数据将不会纳入上报时机数",
              confirmButtonText: "继续观察",
              cancelButtonText: "取消",
              closeOnClickOverlay: true,
            })
              .then(() => {
                this._goWho(item, item2);
                // on confirm
              })
              .catch(() => {
                // on cancel
              });
              return
          }
        })
        if(!flag){
          setTimeout(()=>{
            // 在科室里 =直接去观察
            this._goWho(item, item2);
          },200)
        }
      }
    },
    _goWho(item1, item2) {
      let title = this.headTitle;
      let taskTYpe = this.indexLibId; // 1WHO通用2实验室，3其余  2358外科手消毒
      let departmentId = item2.departmentId;
      let departmentName = item2.departmentName;
      let wardId = item2.wardId;
      let wardName = item2.wardName;
      let originWardName = item2.originWardName;
      let toolsId = this.$route.query.indexCode == 1 ? 400340 : 400521
      let parmas = {
        title,
        taskTYpe,
        departmentId,
        departmentName,
        wardId,
        wardName: originWardName,
        toolsId
      };
      let paramsStr = JSON.stringify(parmas);
      console.log(paramsStr, "who参数");
      // return
      try {
        uni.postMessage({
          data: {
            action: 'startWhohh',
            data: {
              shareTitle: title,
              shareTaskTYpe: taskTYpe,
              departmentId: departmentId,
              departmentName: departmentName,
              wardId: wardId,
              wardName: originWardName,
              toolsId: toolsId
            }
          }
        });
        window.webkit.messageHandlers.startWhohh.postMessage({
          shareTitle: title,
          shareTaskTYpe: taskTYpe,
          departmentId: departmentId,
          departmentName: departmentName,
          wardId: wardId,
          wardName: originWardName,
          toolsId: toolsId
        });
      } catch (err) {
        window.gk.startWhohh(paramsStr);
      }
    },
    // 获取标准科室手卫生依从性完成情况
    searchStandradDeptHandCompletionList() {
      let parmas = {
        userId: this._userInfo.data.userId,
        comId: this._userInfo.data.comId,
        data: {
          comId: this._userInfo.data.comId,
          userId: this._userInfo.data.userId,
          taskId: this.$route.query.taskId,
          taskLinkId: this.$route.query.taskLinkId,
          indexCode: this.$route.query.indexCode
        },
      };

      this.$http.searchStandradDeptHandCompletionList(parmas).then((res) => {
        this.hadLoaded = true;
        if (res.code == 0) {
          let arr = res.data ? res.data : [];
          arr.forEach((v) => {
            v.children = v.children ? v.children : [];
          });
          this.deptCompletionList = arr;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    jumpTo(path) {
      this.$router.push({
        path,
        query: {
          taskId: this.$route.query.taskId,
          taskLinkId: this.$route.query.taskLinkId,
          reportStatus: this.$route.query.reportStatus,
          indexCode: this.$route.query.indexCode,
          stepIsEnd: this.$route.query.stepIsEnd
        },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.complianceMonitor {
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  .container {
    flex: 1;
    overflow: scroll;
  }
  .tips {
    min-height: 64px;
    box-sizing: border-box;
    padding: 14px 12px 10px;
    background-color: #f7f8fa;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  .title-bar {
    box-sizing: border-box;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    opacity: 1;
    background: #ffffff;
    .text {
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #666666;
    }
    .left {
      text-align: left;
      // flex: 1;
    }
    .mid {
      // width: 140px;
      // margin: 0 12px 0 20px;
      // text-align: left;
      margin-left: 20px;
      flex-shrink: 0;
    }
    .action {
      height: 100%;
      flex-shrink: 0;
      margin-left: auto;
    }
  }
  .unit-item-second-level {
    // padding: 0.32rem 0;
    // display: flex;
    // align-items: center;
    color: #666;
    font-size: 14px;
    min-height: 50px;
    .dept-name {
      flex: 1;
    }
    .count {
      width: 100px;
      margin: 0 20px 0;
      text-align: left;
      flex-shrink: 0;
      font-size: 12px;
    }
    .action {
      height: 100%;
      flex-shrink: 0;
      margin-left: auto;
      span {
        margin-right: 5px;
        color: #26b4ff;
        line-height: 20px;
      }
      img {
        width: 15px;
        height: 15px;
      }
    }
    border-bottom: 0.02667rem solid #ebedf0;
  }
  .watch-record-btn {
    height: 60px;
    position: fixed;
    width: 100%;
    bottom: 0;
    background: #ffffff;
    font-size: 18px;
    color: #1c91ff;
  }
  //  标题
  /deep/ .van-collapse-item__content {
    background: #f5f9ff;
  }
  /deep/ .van-collapse-item__wrapper {
    background: #f5f9ff;
  }
  /deep/ .van-collapse-item {
    // height: 50px;
    margin-bottom: 6px;
  }
  /deep/ .van-cell {
    display: flex;
    align-items: center;
    height: 50px;
    padding-left: 12px;
    padding-right: 12px;
  }
  /deep/ .van-cell::after {
    left: 0;
    right: 0;
  }
  /deep/ .van-cell__right-icon::before {
    margin-left: 2px;
    color: #333;
  }
  //   子文件
  /deep/ .van-collapse-item--border::after {
    left: 0;
    right: 0;
  }
  /deep/ .van-cell__title {
    text-align: left;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #333333;
  }
  /deep/ .van-collapse-item__content {
    padding: 0 12px;
    background: #f5f9ff;
  }
  /deep/ .van-collapse-item__content {
    padding: 0 12px;
    background: #f5f9ff;
  }
  /deep/ .van-collapse-item__content .unit-item-second-level:last-child {
    border-bottom: 0;
  }
  .cell-title {
    // width: 500px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .dept_count {
      width: 55px;
      transform: translateX(59px);
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: left;
      // text-align: center;
      color: #333333;
      // line-height: 20px;
    }
  }
}
</style>